<template>
  <div>
    <p>
      Logistic regression allows you to generate models that predict a binary dependent variable from one or more independent, or predictor, variables.  For example, imagine that you are interested in learning the impact of tobacco use and exercise on obesity risk.  The odds ratios produced in a logistic regression model will help you interpret the direction and degree of influence of these predictors.
    </p>
    <h3>Creating a logistic regression</h3>
    <p>
      To generate a model to help answer this question, follow these steps.  Note that "My Analysis" on the bottom right of your screen is updated as you make selections.
    </p>

    <p>
      <ol>
        <li>Select Logistic Regression on the main page or in the menu on the left.</li>
        <li>Select any year and click the "Next" button.</li>
        <li>Select any location and click the "Next" button.  Do not select "All Locations" at this time, as the length of time to generate the logistic regression might be longer than you care to wait.</li>
        <li>On the "Select Dependent Variable" step</li>
        <ul>
          <li>Select the topic "Demographic Information"</li>
          <li>Select the variable "Overweight or obese risk factor"</li>
          <li>Click the "Next" button to continue.</li>
        </ul>
        <li>On the "Select Independent Variable(s)" step</li>
        <ul>
          <li>Select the topic "Exercise"</li>
          <li>Select the variable "During the past month, any physical activities or exercises such as running, calisthenics, golf, gardening, or walking (EXERANY2)"</li>
          <li>Click the "add" button.  You cannot click "Next" until at least one variable has been added, and notice that the equation in the "My Analysis" box is updated.</li>
          <li>To add an additional independent variable, select the topic "Tobacco Use"</li>
          <li>Select "Adults who are current smokers"</li>
          <li>Click the "add" button.</li>
          <li>Click the "Next" button to continue.</li>
        </ul>
        <li>Select the "At Risk" as the reference category for the dependent variable, and keep the preset setting for the other reference categories. Click on "Run Report."</li>
        <li>Review the resulting regression model on the screen.  
          Note that the odds ratio for obesity among those who have not exercised in the past 30 days is above 1.00, meaning that their risk is greater than those who have exercised.</li>
      </ol>
    </p>

    <p>
      To add or change variables, use the "Back" button to find the appropriate step.19641985
        Your original selected variables will be available for you to modify as needed.
      If you want to download results to a spreadsheet, click on the "Download Results" link.
    </p>

    <p>
      The WEAT allows users to change the reference groups for some independent variables.  On the last step, simply select the desired level of any categorical variables for your reference variable before clicking on "Run Report" to see the results.
    </p>
  </div>
</template>

<script>
import current from "@/scripts/current";

export default {
  data: function () {
    current.initializeLogisticRegressionHelp();
    return {};
  },
  methods: {},
};
</script>

<style scoped>
</style>
